import React from 'react';
import IconFacebook from '@components/svgs/facebook-icon.svg';
import IconX from '@components/svgs/x-icon.svg';
import IconInstagram from '@components/svgs/instagram-icon.svg';
import IconPinterest from '@components/svgs/pinterest-icon.svg';
import IconYoutube from '@components/svgs/youtube-icon.svg';

function SocialIcons() {
  return (
    <div className="flex flex-wrap w-full text-center my-8 items-center md:content-start md:m-0">
      <a
        href="https://www.facebook.com/petsafebrand"
        rel="noopener noreferrer"
        target="_blank"
        className="w-1/3 mb-5 md:w-[30%] md:my-2 md:mx-1 group"
      >
        <IconFacebook className="h-14 w-14 bg-no-repeat bg-center md:h-9 md:w-9 lg:h-14 lg:w-14 fill-brand group-hover:fill-white" />
      </a>
      <a
        href="https://www.x.com/petsafe"
        rel="noopener noreferrer"
        target="_blank"
        className="w-1/3 mb-5 md:w-[30%] md:my-2 md:mx-1 group"
      >
        <IconX className="h-14 w-14 bg-no-repeat bg-center md:h-9 md:w-9 lg:h-14 lg:w-14 fill-brand group-hover:fill-white" />
      </a>
      <a
        href="https://www.instagram.com/petsafe/"
        rel="noopener noreferrer"
        target="_blank"
        className="w-1/3 mb-5 md:w-[30%] md:my-2 md:mx-1 group"
      >
        <IconInstagram className="h-14 w-14 bg-no-repeat bg-center md:h-9 md:w-9 lg:h-14 lg:w-14 fill-brand group-hover:fill-white" />
      </a>
      <a
        href="https://www.pinterest.com/petsafe/"
        rel="noopener noreferrer"
        target="_blank"
        className="w-1/3 mb-5 md:w-[30%] md:my-2 md:mx-1 group"
      >
        <IconPinterest className="h-14 w-14 bg-no-repeat bg-center md:h-9 md:w-9 lg:h-14 lg:w-14 fill-brand group-hover:fill-white" />
      </a>
      <a
        href="https://www.youtube.com/user/petsafebrand/"
        rel="noopener noreferrer"
        target="_blank"
        className="w-1/3 mb-5 md:w-[30%] md:my-2 md:mx-1 group"
      >
        <IconYoutube className="h-14 w-14 bg-no-repeat bg-center md:h-9 md:w-9 lg:h-14 lg:w-14 fill-brand group-hover:fill-white" />
      </a>
      <a
        href="https://www.petsafe.com/blog/"
        rel="noopener noreferrer"
        target="_blank"
        className="text-white no-underline text-2xl font-normal hover:underline md:mt-4 md:w-full md:basis-full md:text-left"
      >
        Good Reads by PetSafe
      </a>
    </div>
  );
}

export default SocialIcons;
